import * as Sentry from '@sentry/react';
import {Env} from '../config/env-vars';
import {useEffect} from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import {User} from '../types';

const {name: envName, sentryDSN} = Env;
const shouldEnableSentry = envName === 'production' && !!Env.sentryDSN;

const regexMixpanel = /mixpanel/gi;
const excludedHttpBreadcrumbs = [regexMixpanel];
const processBreadcrumb = (
  breadcrumb: Sentry.Breadcrumb
): null | Sentry.Breadcrumb => {
  if (breadcrumb.category === 'xhr' && breadcrumb.data) {
    const {url} = breadcrumb.data;
    if (excludedHttpBreadcrumbs.some((regex) => regex.test(url))) {
      return null;
    }
  }
  return breadcrumb;
};

Sentry.init({
  dsn: sentryDSN,
  beforeBreadcrumb: processBreadcrumb,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  ignoreErrors: [
    'ResizeObserver loop limit exceeded', // https://stackoverflow.com/a/50387233
  ],

  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^\/api/],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  
  environment: Env.name,

  enabled: shouldEnableSentry,
});

export const setUser = (user: User | null) => {
  Sentry.setUser(user ? {id: `${user.id}`, email: user.email} : null);
};